import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BubbleContent from 'components/customer/conversation_history/conversation_items_v2/content/bubble_content';
import canViewSidekickConversation from 'actions/message_automation/can_view_sidekick_conversation';
import connect from 'components/lib/connect';
import ConversationItem from 'models/conversation_item';
import InlineAnnotatedContentContainer from 'components/lib/inline_annotated_content_container';
import NavigateToSidekickConversation from 'actions/message_automation/navigate_to_sidekick_conversation';
import OpenExternalIcon from 'components/lib/icons/open_external_icon';
import SafeHtml from 'components/common/safe_html';
import Tooltip from 'components/common/tooltip';
import { convertMarkdownToHtml } from 'scripts/lib/markdown_helpers';

export function AutomationSummaryContent(props) {
  let summary = props.item.content.summary.description;

  try {
    summary = JSON.parse(summary);
    // eslint-disable-next-line
  } catch (e) {}

  const viewAIButton = props.canViewSidekickConversation ? (
    <Tooltip message="Open Gladly AI Conversation" position="top">
      <ViewAIButton
        aria-label="Open Gladly AI Conversation"
        data-aid="viewGladlyAIConversationButton"
        onClick={props.onViewSidekickConversation}
      >
        <StyledOpenExternalIcon aria-hidden="true" />
      </ViewAIButton>
    </Tooltip>
  ) : null;

  if (typeof summary === 'object') {
    return (
      <BubbleContent className={classnames('automationItem-content', props.className)} item={props.item}>
        <SummaryHeader>
          <Bold>
            <InlineAnnotatedContentContainer id={props.item.id} key={props.item.id} text="Summary" />
          </Bold>
          {viewAIButton}
        </SummaryHeader>
        <InlineAnnotatedContentContainer
          id={props.item.id}
          key={props.item.id}
          text={summary.summary || 'Summary unavailable'}
        />
      </BubbleContent>
    );
  }

  const htmlContent = convertMarkdownToHtml(summary);

  return (
    <BubbleContent className={classnames('automationItem-content', props.className)} item={props.item}>
      <SummaryHeader>
        <Bold>
          <InlineAnnotatedContentContainer id={props.item.id} key={props.item.id} text="Summary" />
        </Bold>
        {viewAIButton}
      </SummaryHeader>
      <MarkdownContent html={htmlContent} />
    </BubbleContent>
  );
}

AutomationSummaryContent.propTypes = {
  canViewSidekickConversation: PropTypes.bool,
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  onViewSidekickConversation: PropTypes.func,
};
export default connect(mapStateToProps, mapExecuteToProps)(AutomationSummaryContent);

function mapStateToProps(context, props) {
  return {
    ...props,
    canViewSidekickConversation: canViewSidekickConversation(context, props.item),
  };
}

function mapExecuteToProps(executeAction, props) {
  return {
    onViewSidekickConversation: () => {
      executeAction(NavigateToSidekickConversation, { item: props.item });
    },
  };
}

const SummaryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const Bold = styled.span`
  font-weight: bold;
`;

const MarkdownContent = styled(SafeHtml)`
  strong {
    font-weight: bold;
  }
`;

const ViewAIButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  color: ${p => p.theme.colors.gray800};
  cursor: pointer;
  line-height: 0;
  transition: color 0.15s ease;

  &:hover {
    color: ${p => p.theme.colors.green400};
  }
`;

const StyledOpenExternalIcon = styled(OpenExternalIcon)`
  width: 16px;
  height: 16px;
  display: block;
  position: relative;
  top: 2px;
`;
